import { useEffect, useState } from 'react';
import { isNull } from 'utils/lodashExtracts';

const useNavbarEffect = () => {
  const [navbarFixed, setNavbarFixed] = useState(false);

  useEffect(() => {
    const navbar = document.getElementById('navbar-menu');

    let prevScrollpos = window.pageYOffset;
    const scrollListener = () => {
      const currentScrollPos = window.pageYOffset;
      const deadZone = document.querySelector('.hide-navbar-over-section');
      const overDeadzone = !isNull(deadZone) && currentScrollPos > deadZone.offsetTop && currentScrollPos < deadZone.offsetTop + deadZone.offsetHeight
      const onDesktop = window.matchMedia('(min-width: 1100px)').matches
      if (!(overDeadzone && onDesktop) && !navbarFixed) {
        // Go Up
        navbar.style.position = 'fixed';
        navbar.style.top = '0';
      } else if (!navbarFixed) {
        // Go Down
        navbar.style.transition = 'top ease-in-out 0.3s';
        // navbar height(88px) + contact-banner height(34px)
        navbar.style.top = '-122px';
      }
      prevScrollpos = currentScrollPos;
    };
    if (!isNull(navbar)) {
      window.addEventListener('scroll', scrollListener);
      return () => {
        window.removeEventListener('scroll', scrollListener);
      }
    }
  }, []);

  return [navbarFixed, setNavbarFixed]
}

export default useNavbarEffect
